import { User } from '@/types/models'
import { ChangeClientUrl, Navigation } from '@/types'
import { Link } from '@/Components/Navigation/Link'
import ApplicationLogo from '@/Components/Assets/ApplicationLogo'
import { classNames } from '@/Utils/Utils'
import { BottomNavigationList, NavigationList } from './NavigationList'
import { ClientNavigationSection } from './ClientNavigationSection'
import { UserMenuBottom } from '../UserMenu'

interface DesktopSidebarProps {
    user: User
    navigation: Navigation
    changeClientUrl?: ChangeClientUrl
}

export function DesktopSidebar({ user, navigation, changeClientUrl }: DesktopSidebarProps) {
    return (
        <div className="hidden border-r border-stone-300/60 bg-white lg:fixed lg:inset-y-0 lg:z-10 lg:flex lg:w-72 lg:flex-col">
            <div className="mt-2 flex grow flex-col gap-y-5 overflow-hidden overflow-y-auto px-6 pt-4 pb-4">
                <div className="-mx-3 flex h-12 shrink-0 items-center">
                    <Link href={route('dashboard')}>
                        <ApplicationLogo className="w-full" />
                    </Link>
                </div>

                <nav className="flex flex-1 flex-col" aria-label="Sidebar">
                    <ul role="list" className="flex flex-1 flex-col gap-y-7">
                        <li className="grow">
                            <div className="relative -mx-2 h-full">
                                <ul
                                    role="list"
                                    className={classNames(
                                        'flex w-full flex-col space-y-0.5 border-t border-stone-200 pt-1 transition-all duration-300 ease-in-out',
                                        navigation.displayClientNavigation
                                            ? 'pointer-events-none absolute inset-0 -translate-x-full opacity-0'
                                            : 'relative translate-x-0 opacity-100'
                                    )}
                                >
                                    <NavigationList items={navigation.sections.global} />
                                </ul>

                                <ul
                                    role="list"
                                    className={classNames(
                                        'flex w-full flex-col space-y-1 transition-all duration-300 ease-in-out',
                                        navigation.displayClientNavigation
                                            ? 'relative translate-x-0 opacity-100'
                                            : 'pointer-events-none absolute inset-0 translate-x-full opacity-0'
                                    )}
                                >
                                    {navigation.displayClientNavigation && (
                                        <ClientNavigationSection navigation={navigation} changeClientUrl={changeClientUrl!} />
                                    )}
                                </ul>
                            </div>
                        </li>

                        <li className="mt-auto">
                            <ul role="list" className="-mx-2 mb-5 space-y-0.5">
                                <BottomNavigationList items={navigation.sections.bottom} />
                            </ul>

                            <UserMenuBottom user={user} userNavigation={navigation.sections.user} />
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}
